// Wrapper.js
import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import Detail from "./index";

const DetailWrapper = () => {
    const params = useParams();
    const location = useLocation();
    const history = useHistory();

  return <Detail match={{ params }} location={location} history={history} />;
};

export default DetailWrapper;
